import { DirectOrderCheckpointLabelTextHelper } from './labelTextHelper/DirectOrderCheckpointLabelTextHelper';
import { ImportTableLabelTextHelper } from './labelTextHelper/ImportTableLabelTextHelper';
import { HeaderItem } from '../model/HeaderItem';

export const DirectOrderCheckpointHeaderHelper = {
    /**
     * Get all header items for checkpoint fields
     */
    getHeaderItems(): HeaderItem[] {
        return [
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.directOrderNumber,
                value: 'directOrderNumber'
            },
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.checkpointTimeUtc,
                value: 'checkpointTimeUtc'
            },
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.tag,
                value: 'tag'
            },
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.subTag,
                value: 'subTag'
            },
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.message,
                value: 'message'
            }
        ];
    },

    /**
     * Get field definitions for CSV importer component
     * Returns an object with field keys and their configuration (required, label)
     */
    getCheckpointFields() {
        return this.getHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    /**
     * Get headers for preview table (same as header items)
     */
    getPreviewHeaders() {
        return this.getHeaderItems();
    },

    /**
     * Get headers for import submit table
     * Includes status, error, direct order number, and checkpoint list columns
     */
    getImportSubmitHeaders(): HeaderItem[] {
        return [
            {
                text: ImportTableLabelTextHelper.getLabelText.status,
                value: 'status'
            },
            {
                text: ImportTableLabelTextHelper.getLabelText.error,
                value: 'error'
            },
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.directOrderNumber,
                value: 'directOrderNumber'
            },
            {
                text: DirectOrderCheckpointLabelTextHelper.getLabelText.directOrderCheckpointList,
                value: 'directOrderCheckpointList'
            }
        ];
    }
};
